I<template>
  <div class="cell-item">
    <span>
      <label v-if="$slots.title" class="title">{{ label }}</label>
      <label v-else class="title">{{ label }}</label>
      <span v-if="$slots.value" class="value"><slot name="value"></slot></span>
      <span v-else class="value">{{ value }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "CellItem",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.cell-item {
  padding: 0.2rem 0.3rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  .title {
    display: inline-block;
    width: 2.2rem;
  }
  .value {
    display: inline-block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }
}
</style>
